import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import RamsTab from '../../../RamsTab';
import { apiFetch } from '../../../utils/api';

function JobRamsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);

  useEffect(() => {
    fetchJob();
  }, [id]);

  const fetchJob = async () => {
    try {
      const res = await apiFetch(`/api/jobs/${id}`);
      if (res.ok) {
        const data = await res.json();
        setJob(data);
      }
    } catch (err) {
      console.error('Error fetching job:', err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-md">
        <div className="max-w-full mx-auto px-6 py-3 flex items-center justify-between">
          <button
            onClick={() => navigate('/jobs')}
            className="text-white hover:text-blue-100 transition text-sm font-semibold"
          >
            ⬅ Back to Jobs
          </button>
          <div className="text-center">
            <h1 className="text-xl font-bold">Job #{job?.job_number}</h1>
          </div>
          <div className="w-32" />
        </div>
      </div>

      {/* Tab Bar */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-full mx-auto px-6 flex items-center gap-1">
          <TabLink to={`/jobs/${id}`} label="Job Details" />
          <TabLink to={`/jobs/${id}/appointments`} label="Appointments" />
          <TabLink to={`/jobs/${id}/materials`} label="Materials" />
          <TabLink to={`/jobs/${id}/rams`} label="RAMS" active />
        </div>
      </div>

      {/* RAMS Content */}
      <div className="p-6 max-w-5xl mx-auto">
        <RamsTab jobId={id} jobData={job} />
      </div>
    </div>
  );
}

function TabLink({ to, label, active }) {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate(to)}
      className={`px-4 py-3 text-sm font-medium border-b-2 transition ${
        active
          ? 'border-blue-600 text-blue-700'
          : 'border-transparent text-gray-500 hover:text-gray-700'
      }`}
    >
      {label}
    </button>
  );
}

export default JobRamsPage;
